import api from '../api';

export default class IdentidadeGeneroService {
  constructor() {
    throw 'Não é possível instanciar IdentidadeGeneroService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `identidades-generos`;
};



// WEBPACK FOOTER //
// ./src/services/enums/identidadeGeneroService.js